import { GlobalState } from '@highlight/ipc'

type DetectionStringType = 'image' | 'clipboardText' | 'selectedText'
type DetectedClipboard = {
  type: 'clipboardText'
  value: string
}
type DetectedSelectedText = {
  type: 'selectedText'
  value: string
}
type DetectedImage = {
  type: 'image'
  value: string
}
// type DetectedSelectedText = {
//   type: 'selectedText'
//   value: string
// }
export type DetectedType = DetectedImage | DetectedClipboard | DetectedSelectedText

export const getCurrentDetection = (type?: DetectionStringType) => {
  const current = GlobalState.get<DetectedType>('currentDetection')
  if (type && current?.type !== type) {
    return undefined
  }
  return current
}

export const setCurrentDetection = (detected: DetectedType) => {
  GlobalState.set('currentDetection', detected)
}

export const clearCurrentDetection = (type?: DetectionStringType) => {
  if (type) {
    const current = getCurrentDetection()
    if (current?.type !== type) {
      return
    }
  }
  GlobalState.delete('currentDetection')
}
